import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useSubscriptionApi() {
  const callApi = useApiCall();

  const getSubscriptionPlans = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SUBSCRIPTION.GET_SUBSCRIPTION_PLANS, data, onSuccess, onError);
  };

  const createPayment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SUBSCRIPTION.CREATE_PAYMENT, data, onSuccess, onError);
  };

  const paymentSuccess = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SUBSCRIPTION.PAYMENT_SUCCESS, data, onSuccess, onError);
  };

  const paymentCancel = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.SUBSCRIPTION.PAYMENT_CANCEL, data, onSuccess, onError);
  };

  const getInvoices = (params: { per_page?: number; page?: number }, onSuccess: Function, onError: Function) => {
    console.log("Fetching invoices with params:", params);
    callApi(SAGA_ACTIONS.SUBSCRIPTION.GET_INVOICES, params, onSuccess, onError);
  };

  const cancelSubscription = (
    data: { subscription_id: string; reason: string },
    onSuccess: Function,
    onError: Function
  ) => {
    callApi(SAGA_ACTIONS.SUBSCRIPTION.CANCEL_SUBSCRIPTION, data, onSuccess, onError);
  };

  return {
    callGetSubscriptionPlans: getSubscriptionPlans,
    callGetInvoices: getInvoices,
    callCreatePayment: createPayment,
    callPaymentSuccess: paymentSuccess,
    callPaymentCancel: paymentCancel,
    callCancelSubscription: cancelSubscription,
  };
}
